import script from "./invest.vue?vue&type=script&lang=ts&setup=true"
export * from "./invest.vue?vue&type=script&lang=ts&setup=true"

import "./invest.vue?vue&type=style&index=0&id=265f9dfa&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265f9dfa"]])

export default __exports__